import { create } from 'zustand'

/**
 * Live stock shared by the basket drawer and checkout (BUG-453): the latest available count per SKU,
 * and which basket lines were lowered to it, so "Only 2 left, quantity updated" shows wherever the
 * line is seen until the customer changes it.
 */
interface StockState {
  live: Record<string, number> | null
  adjusted: Record<string, number>
  setLive: (live: Record<string, number>) => void
  noteAdjusted: (lines: Record<string, number>) => void
  forget: (key: string) => void
}

export const useStockStore = create<StockState>((set) => ({
  live: null,
  adjusted: {},
  setLive: (live) => set({ live }),
  noteAdjusted: (lines) => set((s) => ({ adjusted: { ...s.adjusted, ...lines } })),
  forget: (key) =>
    set((s) => {
      const adjusted = { ...s.adjusted }
      delete adjusted[key]
      return { adjusted }
    }),
}))
